//Page Setting

//----------------------------------------------

export const PAGE_SETTING = {
  name: 'Nestflo'
};

export const BOOK_DEMO_URL =
  // 'https://calendly.com/roland-tao-55/30min?month=2024-02';
  'https://nestflo.zohobookings.com/#/4685022000000042016';
export const VIDEO_URL =
  'https://kunpro.s3.eu-west-2.amazonaws.com/sites/h264_1080_best_2025.mp4';
export const VIDEO_DEMO_URL =
  'https://kunpro.s3.eu-west-2.amazonaws.com/sites/Lark20250501-094428.mp4';

//goodmanlilley
export const GOODMANLILLEY_URL =
  'https://kunpro-prod.s3.eu-west-2.amazonaws.com/site/Lark20240918-042252.mp4';

//GREENWOODS_URL
export const GREENWOODS_URL =
  'https://kunpro.s3.eu-west-2.amazonaws.com/sites/Lark20240903-105025.mp4';

//BESTE_JEFFER_URL˚
export const BESTE_JEFFER_URL =
  'https://kunpro-prod.s3.eu-west-2.amazonaws.com/site/Lark20240918-042056.mp4';
export const BESTE_JEFFER_lTD_URL = '';
export const SYZO_LTD_URL =
  'https://kunpro-prod.s3.eu-west-2.amazonaws.com/site/Lark20240918-042301.mp4';

export const PETER_ELLIS_URL =
  'https://kunpro-prod.s3-eu-west-2.amazonaws.com/site/Lark20241021-130240.mp4';

export const RG_PROPERTY_URL =
  'https://kunpro-prod.s3.eu-west-2.amazonaws.com/site/Lark20240918-035839.mp4';

export const REGISTER_URL = 'https://office.nestflo.ai/package/trial/';
export const LOGIN_URL = 'https://office.nestflo.ai/auth/login/';

/** ListSync 渠道办公端根地址（导航「Log in」入口） */
export const LISTSYNC_LOGIN_URL = 'https://automarketing.listsync.co.uk/';

export const MENU = [
  {
    title: 'Why Use Nestflo?',
    showInPc: true,
    href: '/#link_1'
  },
  {
    title: 'TESTIMONIALS',
    diableInMobile: true,
    showInPc: true,
    href: '/look'
  },
  {
    title: 'Case Study',
    showInPc: false,
    href: '/look#CaseStudy'
  },
  {
    title: 'Video Testimonials',
    showInPc: false,
    href: '/#syzo_ltd'
  },
  {
    title: 'FEATURES',
    showInPc: true,
    href: '/#link_2'
  },
  {
    title: 'GETS YOU STARTED',
    showInPc: true,
    href: '/#link_4'
  },
  {
    title: 'PRICING',
    showInPc: true,
    href: '/#price'
  },
  // {
  //   title: 'Privacy Policy',
  //   showInPc: true,
  //   href: 'https://nestflo.ai/assets/documents/privacy-policy.html'
  // },
  {
    title: 'About Us',
    showInPc: true,
    href: '/about'
  }
  // {
  //   title: 'QUICK START GUIDE',
  //   href: '/#js-start'
  // },
  // {
  //   title: 'LOGIN',
  //   href: LOGIN_URL
  // }
] as const;
